<template>
  <session class="mobile-page-login">
    <Header />
    <!-- <div class="login-comp-wrap"> -->
      <!-- <div class="login-comp-l"> -->
      <div class="login-form-block">
        <div class="blocktitle">
          <span class="main">{{LOCAL('exchange_title')}}</span>
          <!-- <span class="sub" v-html="Utils.presetHtmlText(LOCAL('exchange_welcome_txt'))" /> -->
        </div>
        <div class="blockform-wrap">
          <div class="item-label" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ LOCAL('exchange_loginType_1_title') }}</div>
          <div class="item">
            <Icon name="key" size="18" />
            <div class="input-wrap"><input v-model="accountValue" :placeholder="`${LOCAL('exchange_loginType_1_plsholder')}`" /></div>
            <div class="errortip" v-if="showAccountError">密钥错误，请重试</div>
          </div>
        </div>
        <div class="blockform-wrap2">
          <div class="submitbtn" @click="submitHandle"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('exchange_btn')}}</span></div>
          <div class="tipdesc">
            <label :class="{ ffen: getLocalLangCode() != 'zh' }">{{ LOCAL('exchange_description_title') }}</label>
            <span v-html="Utils.presetHtmlText(LOCAL('exchange_description_txt'))" />
          </div>
        </div>
      </div>
  </session>
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue';
  import * as Utils from '@/assets/utils';
  import Header from '@/mobile/components/header/index.vue';
  import Icon from '@/components/icon/index.vue';
  import EventBus from '@/assets/eventbus';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';

  // 流出步骤
  const step = ref(1);  // 1 - 第一步；2 - 第二步

  const show = ref(false);
  onMounted(() => {
    EventBus.on('mobile_login_dialog_key', (data = null) => {
      show.value = data?.flag || false
      step.value = 1;
    });
  });

  /**
   * 第一步
   */
  // 入口列表
  const entrancesList = ref([]);
  const curEntrance = ref(null);
  const init = () => {
    entrancesList.value = [
      { title: LOCAL('login_loginType_1_title'), desc: LOCAL('login_loginType_1_desc'), icon: 'person-blue', id: 'person' },
      { title: LOCAL('login_loginType_2_title'), desc: LOCAL('login_loginType_2_desc'), icon: 'enterprise-blue', id: 'enterprise' },
      { title: LOCAL('login_loginType_3_title'), desc: LOCAL('login_loginType_3_desc'), icon: 'agent-blue', id: 'agent' },
    ]
  }
  onMounted(() => {
    init()
  });

  // 选择入口
  const selectEntrance = item => {
    curEntrance.value = item;
    step.value = 2;
  }

  /**
   * 第二步
   */
  const showPassword = ref(false);

  const accountValue = ref('');
  const passwordValue = ref('');
  const showAccountError = ref(false);
  const showPasswordError = ref(false);

  // 返回
  const backHandle = () => {
    step.value = 1;
    accountValue.value = '';
    passwordValue.value = '';
    showAccountError.value = false;
    showPasswordError.value = false;
  }

  // 提交
  const submitHandle = () => {
    console.log('accountValue.value', accountValue.value, 'passwordValue.value', passwordValue.value);
    showAccountError.value = false;
    showPasswordError.value = false;

    if(!accountValue.value) {
      showAccountError.value = true;
      return;
    }
    if(!passwordValue.value) {
      showPasswordError.value = true;
      return;
    }
  }
</script>

<style scoped lang="less">
  @import "index.less";
</style>
